/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav.mobile' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // PRIMARY NAVIGATION
      $( '.desktop .primary-menu-item' ).on( 'mouseover', function() {
        const menuItem = $( this ).data( 'menu-item' );
        let menuItemNum = menuItem.replace( 'mi-', '' );
        const nextMenuItemNum = menuItemNum++;
        $( '.vr-'+menuItemNum ).addClass( 'active' );
        $( '.vr-'+nextMenuItemNum ).addClass( 'active' );
      } );

      $( '.desktop .primary-menu-item' ).on( 'mouseout', function() {
        const menuItem = $( this ).data( 'menu-item' );
        let menuItemNum = menuItem.replace( 'mi-', '' );
        const nextMenuItemNum = menuItemNum++;
        $( '.vr-'+menuItemNum ).removeClass( 'active' );
        $( '.vr-'+nextMenuItemNum ).removeClass( 'active' );
      } );

      // submit newsletter form in sidebar
      $( document ).on( 'submit', '#footer-newsletter-form', function( e ) {
        e.preventDefault();
        const form = this;

        $.ajax( {
          type: 'post',
          url: site_info.ajax_url,
          data: {
            action: 'll_submit_footer_form',
            formId: $( this ).attr( 'data-form' ),
            fName: $( '#footer-newsletter-fname' ).val(),
            lName: $( '#footer-newsletter-lname' ).val(),
            email: $( '#footer-newsletter-email' ).val(),
            // eslint-disable-next-line
            nonce: $( [name=footer_nonce] ).val(),
          },
          success: function( response ) {
            response = $.parseJSON( response );
            if ( response.type == 'success' ) {
              $( form ).next().show();
              $( form ).hide();
            } else {
              console.log( 'Something went wrong.' );
            }
          },
          error: function( xhr, exception ) {
            let msg = '';
            if ( xhr.status === 0 ) {
              msg = 'Not connect.\n Verify Network.' + xhr.responseText;
            } else if ( xhr.status == 404 ) {
              msg = 'Requested page not found. [404]' + xhr.responseText;
            } else if ( xhr.status == 500 ) {
              msg = 'Internal Server Error [500].' + xhr.responseText;
            } else if ( exception === 'parsererror' ) {
              msg = 'Requested JSON parse failed.';
            } else if ( exception === 'timeout' ) {
              msg = 'Time out error.' + xhr.responseText;
            } else if ( exception === 'abort' ) {
              msg = 'Ajax request aborted.';
            } else {
              msg = 'Error:' + xhr.status + ' ' + xhr.responseText;
            }
            console.log( msg );
          },
        } );
      } );


      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav.mobile' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav.mobile' ).removeClass( 'is-open' );
      } );

      // Shove-in smoothscrolling for a Learn More anchor link
      // thank you Chris Coyier: https://css-tricks.com/snippets/jquery/smooth-scrolling/
      // Select all links with hashes
      $( 'a[href*="#"]:not([href="#"])' ).click( function( e ) {
        e.preventDefault();
        if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname ) {
          let target = $( this.hash );

          target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
          if ( target.length ) {
            document.querySelector( `#${this.hash.slice( 1 )}` ).scrollIntoView( {
              behavior: 'smooth',
              block: 'start',
            } );
          }
        }
      } );

      // FOOTER ARROW ANIMATION


      CustomEase.create( 'fastForwardCommon', '0.390, 0.575, 0.565, 1.000' );

      gsap.from( 'footer.footer .arrows .icon', {
        scrollTrigger: {
          trigger: 'footer.footer',
          start: 'top 50%',
          scrub: false,
        },
        x: '-115vw',
        duration: 0.9,
        lazy: false,
        ease: 'fastForwardCommon',
        stagger: {
          each: 0.15,
          from: 2,
        },
      } );

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
